mutation createTestimonial($text: String!, $tempImage: String!) {
  createPixAPicTestimonial(text: $text, tempImage: $tempImage)
}
